import React, { useEffect, useState } from "react";
import config from "../../utils/config";
import { useDispatch, useSelector } from "react-redux";
import FormControl from "../formControl";
import CustomDropdown from "../presentationals/CustomDropdown";
import { Button } from "@material-ui/core";
import {
  fetchEdJbaFilterList,
  fetchSchemeName,
  fetchSchemeType,
  setSelectedData,
  triggerDashboardAudit,
} from "../../redux/actions";
import { filterNames } from "../../utils/constants";
import { setPayoutDashboard } from "../../redux/actions/action";
import { isEmptyObject, mapTokenToRoleId } from "../../utils/common";
import Skeleton from "@mui/material/Skeleton";
import Tooltip from "@mui/material/Tooltip";

const DashboardFilterForSmbAndFiber = (props) => {
  const dispatch = useDispatch();
  const { changeHandler, runButtonClickHandler, dashboardMenu, type } = props;
  const {
    partnerRoleType,
    filteredArray,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    isPayoutDashboard,
  } = useSelector((state) => state.homeReducer);
  const { ed1FilterObj, selectedData, schemeType, schemeName } = useSelector(
    (state) => state.Ed1AndEd2Reducer
  );

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "run",
        dashboard: type,
        empId: filterValue?.agentId?.length
          ? filterValue?.agentId
          : filterValue?.orgId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: "",
      },
    };
    triggerDashboardAudit(obj);
  };

  const runHandler = () => {
    sendAudit();
    runButtonClickHandler();
  };

  const [isFirstTime, setIsFirstTime] = useState(false);

  const fetchEdJbaList = (signal) => {
    const obj = {
      state: selectedData["State"],
      userType: filterValue?.site,
      type: type,
    };
    dispatch(
      fetchEdJbaFilterList(
        obj,
        (response, params) => {
          changeHandler(
            "Partner Name",
            response?.content.length ? response.content[0] : {}
          );
        },
        signal
      )
    );
  };

  const getSchemeType = (signal) => {
    const obj = {
      headers: {
        url: "/smb-fiber-scheme-type",
      },
      params: {
        fromDate: headerSelectedDateFrom,
        partnerRoleType: config.validateRoleTypes?.[partnerRoleType]
          .businessType
          ? selectedData["Partner Name"]?.partnerRoleType
          : mapTokenToRoleId(partnerRoleType),
        toDate: headerSelectedDateTo,
      },
    };
    dispatch(
      fetchSchemeType(
        obj,
        (response) => {
          changeHandler(
            "Scheme Type",
            response?.content.length ? response.content[0] : ""
          );
        },
        signal
      )
    );
  };

  const getSchemeName = (signal) => {
    const obj = {
      headers: {
        url: "/smb-fiber-scheme-name",
      },
      params: {
        schemeType: selectedData["Scheme Type"],
        smbFiberFilterBaseProcParam: {
          fromDate: headerSelectedDateFrom,
          partnerRoleType: config.validateRoleTypes?.[partnerRoleType]
            .businessType
            ? selectedData["Partner Name"]?.partnerRoleType
            : mapTokenToRoleId(partnerRoleType),
          toDate: headerSelectedDateTo,
        },
      },
    };
    dispatch(
      fetchSchemeName(
        obj,
        (response) => {
          changeHandler("Scheme Name", "ALL");
          if (!isFirstTime) {
            setIsFirstTime(true);
          }
        },
        signal
      )
    );
  };

  useEffect(() => {
    if (isFirstTime) {
      runButtonClickHandler();
    }
  }, [isFirstTime]);

  useEffect(() => {
    const controller = new AbortController();

    if (
      selectedData["State"] !== "" &&
      config.validateRoleTypes?.[partnerRoleType].businessType
    ) {
      fetchEdJbaList(controller.signal);
    }

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedData["State"]]);

  useEffect(() => {
    const controller = new AbortController();

    if (
      isPayoutDashboard?.payout &&
      (!isEmptyObject(selectedData["Partner Name"]) ||
        !config.validateRoleTypes?.[partnerRoleType].businessType)
    ) {
      getSchemeType(controller.signal);
    }

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedData["Partner Name"],
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  useEffect(() => {
    const controller = new AbortController();

    if (
      isPayoutDashboard?.payout &&
      selectedData["Scheme Type"] !== "" &&
      (!isEmptyObject(selectedData["Partner Name"]) ||
        !config.validateRoleTypes?.[partnerRoleType].businessType)
    ) {
      getSchemeName(controller.signal);
    }

    // Cleanup function to cancel the request if the component unmounts
    return () => {
      controller.abort(); // Cancels the request when the component unmounts
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedData["Scheme Type"],
    headerSelectedDateFrom,
    headerSelectedDateTo,
  ]);

  useEffect(() => {
    if (
      selectedData["Region"] === "" &&
      selectedData["State"] === "" &&
      config.validateRoleTypes?.[partnerRoleType].businessType
    ) {
      filterValue.selectedRole.toLowerCase() === "nhq"
        ? dispatch(
            setSelectedData({
              ...selectedData,
              Region: "North",
              State: "Delhi",
            })
          )
        : filterValue.selectedRole.toLowerCase() === "region head"
        ? dispatch(
            setSelectedData({
              ...selectedData,
              Region: filterValue.selectedRegion,
              State:
                config.states[config.regionMaps[filterValue.selectedRegion]][0],
            })
          )
        : dispatch(
            setSelectedData({
              ...selectedData,
              State: filterValue.selectedState,
            })
          );
    }
  });

  return (
    <div className="whitebox mt-sm-5 mb-1">
      <form autoComplete="off">
        {dashboardMenu?.[partnerRoleType]?.map((data, index) => {
          return (
            <FormControl
              key={index}
              variant={data.variant}
              type={data.type}
              styleName={data.className}
            >
              {data.type === "form" ? (
                (
                  data.name === "Partner Name"
                    ? ed1FilterObj.loading
                    : data.name === "Scheme Type"
                    ? schemeType.loading
                    : data.name === "Scheme Name"
                    ? schemeName.loading
                    : false
                ) ? (
                  <Skeleton variant="rectangular" width={200} height={40} />
                ) : (
                  <CustomDropdown
                    name={data.name}
                    data={
                      data.name === "Region"
                        ? config.region
                        : data.name === "State"
                        ? config.states[
                            config.regionMaps[
                              selectedData["Region"].toUpperCase()
                            ]
                          ]
                        : data.name === "Partner Name"
                        ? ed1FilterObj?.data
                          ? ed1FilterObj.data.content.length
                            ? ed1FilterObj.data.content.map((row) => row)
                            : []
                          : ed1FilterObj?.error
                          ? "Error fetching data"
                          : ""
                        : data.name === "Scheme Type"
                        ? schemeType?.data
                          ? schemeType.data.content
                          : schemeType?.error
                          ? "Error fetching data"
                          : ""
                        : data.name === "Scheme Name"
                        ? schemeName?.data
                          ? schemeName.data.content.length
                            ? [
                                "ALL",
                                ...schemeName.data.content.map(
                                  (obj) => obj.schemeCode
                                ),
                              ]
                            : []
                          : schemeName.error
                          ? "Error fetching data"
                          : ""
                        : "Error fetching data"
                    }
                    loading={
                      data.name === "Partner Name"
                        ? ed1FilterObj.loading
                        : data.name === "Scheme Type"
                        ? schemeType.loading
                        : data.name === "Scheme Name"
                        ? schemeName.loading
                        : false
                    }
                    changeHandler={(value) => changeHandler(data.name, value)}
                    value={selectedData[data.name]}
                  />
                )
              ) : type !== "Payout Dashboard" ||
                (schemeType?.data?.content?.length &&
                  schemeName?.data?.content?.length) ? (
                <Button
                  className="m-2"
                  onClick={() => runHandler()}
                  variant="contained"
                  color="default"
                >
                  Run
                </Button>
              ) : (
                <Tooltip
                  title="Run button will be disabled if no data is available for the selected date"
                  placement="top"
                  arrow
                >
                  <span>
                    <Button
                      className="m-2"
                      onClick={() => runHandler()}
                      variant="contained"
                      color="default"
                      disabled
                    >
                      Run
                    </Button>
                  </span>
                </Tooltip>
              )}
            </FormControl>
          );
        })}
      </form>
    </div>
  );
};

export default DashboardFilterForSmbAndFiber;
